import { createSlice } from '@reduxjs/toolkit';
import type { IPGeolocationResponse } from '@services/dto/account';
import { useAppDispatch, useAppSelector } from '@services/state/store';
import React from 'react';
import { getGeolocation } from '../api';

type SessionState = {
  geo?: IPGeolocationResponse;
};

const slice = createSlice({
  name: 'session',
  initialState: {} as SessionState,
  reducers: {
    setGeo: (state, action) => {
      state.geo = action.payload;
    },
  },
});

const sessionActions = slice.actions;
export const sessionReducer = slice.reducer;

export const useGeolocation = () => {
  const state = useAppSelector((state) => state.session);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (state.geo) return;

    const geo = sessionStorage.ipGeolocation
      ? (JSON.parse(sessionStorage.ipGeolocation) as IPGeolocationResponse)
      : null;
    if (geo) {
      dispatch(sessionActions.setGeo(geo));
      return;
    }

    getGeolocation().then((geo) => {
      sessionStorage.ipGeolocation = JSON.stringify(geo);
      dispatch(sessionActions.setGeo(geo));
    });
  }, []);

  return state.geo;
};
